module.exports = function(){

	jQuery(function($){

		function setHeights(){

			var winW = $(window).width();

			// skip if on mobile
			if(winW < 768)
				return;

			$('[data-col-height-eq]').each(function(i, el){
				var $el = $(el);

				if($el.data('col-height-eq-set'))
					return;
				
				var selector = $el.data('col-height-eq'),
					$sibs = $el.parent().children(selector),
					tallest = 0;

				$sibs.each(function(j, sib){
					var thisH = $(sib).height();

					if(thisH > tallest)
						tallest = thisH;

				});

				$sibs.height(tallest).data('col-height-eq-set', true);

			});
		}

		setHeights();

	});
};